import { useToast } from '@/components/atoms/Toast';
import { dashboardRemoveListsBatchRequest } from '@/modules/dashboard/dashboardActions';
import type { List } from '@/modules/dashboard/dashboardTypes';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useRemoveBatchListMutation = () => {
	const { toast } = useToast();
	const dispatch = useDispatch();

	const mutate = useCallback(
		(ids: Array<List['id']>) => {
			try {
				dispatch(dashboardRemoveListsBatchRequest(ids));

				toast({
					title: `${ids.length} lists removed`,
					variant: 'success'
				});
			} catch (error) {
				toast({
					title: 'Something went wrong with list batch remotion',
					variant: 'error'
				});
			}
		},
		[dispatch, toast]
	);

	return { mutate };
};
